import type {
  ActorBackupRestoreOptions,
  ActorBackupRestoreStatement,
} from "@-/dev.improve.haniverse.lib.database.engine";

/** Replace the study data through the database owner's exclusive restore capability. */
export async function executeBackupRestore(
  connection: object,
  statements: ActorBackupRestoreStatement[],
  options?: ActorBackupRestoreOptions,
): Promise<void> {
  const method: unknown = Reflect.get(connection, "executeBackupRestore");
  if (typeof method !== "function") {
    throw new TypeError("Restore requires the database owner's exclusive restore capability");
  }
  await Reflect.apply(method, connection, options === undefined ? [statements] : [statements, options]);
}
